import { MAX_GRID_WIDTH } from "config/styleConsts";
import { ChakraFlex as Flex, ChakraBox as Box } from "@airhelp/react-ui-components";
import { PressLogosContent } from "./PressLogosContent";

export const PressLogos = () => (
  <Box p={5} bgGradient="linear(to-b, #ffffff 50%, greyscale.300 0)">
    <Flex
      bg="white"
      justify="center"
      align="center"
      flexWrap="wrap"
      maxW={MAX_GRID_WIDTH}
      rounded={{ base: "sm", md: "lg" }}
      boxShadow="alt"
      mx="auto"
      px={{ base: 12, md: 8 }}
      pb={5}
      pt={{ base: 3, md: 5 }}
    >
      <PressLogosContent textColor="primary.900" />
    </Flex>
  </Box>
);
